import React, { useState } from 'react';
//import styles
import style from './a.module.scss'
//import components
import Navbar from '../../components/Navbar/Navbar';
import Footer from '../../components/Footer/Footer';
import TextBox from '../../components/TextBox/TextBox';
import PrimaryButton from '../../components/PrimaryButton/PrimaryButton';
//import assets
import profile from '../../assets/icons/profile.svg';
import emailIcon from '../../assets/icons/material-symbols_mail.svg';
import background from '../../assets/Backgrounds/grid-background.svg';

const Contact = () => {
    const [email, setEmail] = useState('')
    return (
        <div className={style.contact} >
            <Navbar />
            <div className={style.contactContent} style={{ backgroundImage: `url(${background})` }}>
                <div className={style.contactLeftside}>
                    <p>Need help with<br />something?</p>
                    <div className={style.contactFields}>
                        <TextBox type='name' placeholder='Name' icon={profile} inputBox={true}/>
                        <TextBox type='email' placeholder='Email' icon={emailIcon} inputBox={true} onChange={(e) => setEmail(e.target.value)}/>
                        <div className={style.messageBox}>
                            <TextBox type='message' placeholder='Message' icon={emailIcon} inputBox={true}/>
                        </div>
                    </div>
                    <div className={style.sendBtn}>
                        <PrimaryButton title='Send' />
                    </div>
                </div>
                <div className={style.contactRightside}>
                    <p>"Our vision is to build<br />Strong mentor-<br />mentee program for<br />juniors and seniors."</p>
                </div>
            </div>
            <div className={style.footer}>
                <Footer />
            </div>
        </div>
    );
};

export default Contact;